export var FORM_INPUTS = [
    {
        name: 'webhook_value',
        label: 'webhook.name',
        placeholder: 'webhook.name',
    },
];
